module.exports = __webpack_public_path__ + "static/media/TestTypeTwoActive.a068df87.svg";